import React from 'react';


function VIPLevels({ onViewMore }) {
  const vipLevels = [
    { level: 'VIP1', amount: '100.00USDT', image: '/levels/level-1.png' },
    { level: 'VIP2', amount: '500.00USDT', image: '/levels/level-2.png' },
    { level: 'VIP3', amount: '1500.00USDT', image: '/levels/level-3.png' },
    { level: 'VIP4', amount: '5000.00USDT', image: '/levels/level-4.png' },
  ];

  return (
    <div className="vip-levels-section">
      <div className="container-fluid px-3 py-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0 fw-bold">Vip Levels</h5>
          <a 
            href="#" 
            className="text-purple text-decoration-none"
            onClick={(e) => {
              e.preventDefault();
              if (onViewMore) onViewMore();
            }}
          >
            View More <i className="bi bi-arrow-right"></i>
          </a>
        </div>
        <div className="row g-3">
          {vipLevels.map((vip, index) => (
            <div key={index} className="col-6 col-md-3">
              <div className="vip-card">
                <div className={`vip-icon vip-${index + 1}`}>
                  <img src={vip.image} alt={vip.level} className="vip-level-image" />
                </div>
                <div className="vip-title">{vip.level}</div>
                <div className="vip-amount">{vip.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default VIPLevels;

